// extracted by mini-css-extract-plugin
export const main_container = "index-module--main_container--1Y18W";